var map = {
	"./ion-accordion_2.entry.js": [
		83750,
		3750
	],
	"./ion-action-sheet.entry.js": [
		90733,
		8592,
		733
	],
	"./ion-alert.entry.js": [
		20985,
		8592,
		985
	],
	"./ion-app_8.entry.js": [
		93899,
		8592,
		3899
	],
	"./ion-avatar_3.entry.js": [
		5121,
		8592,
		5121
	],
	"./ion-back-button.entry.js": [
		52960,
		8592,
		2960
	],
	"./ion-backdrop.entry.js": [
		45473,
		5473
	],
	"./ion-breadcrumb_2.entry.js": [
		57951,
		8592,
		7951
	],
	"./ion-button_2.entry.js": [
		19787,
		8592,
		9787
	],
	"./ion-card_5.entry.js": [
		66165,
		8592,
		6165
	],
	"./ion-checkbox.entry.js": [
		69569,
		8592,
		9569
	],
	"./ion-chip.entry.js": [
		35119,
		8592,
		5119
	],
	"./ion-col_3.entry.js": [
		90799,
		3647
	],
	"./ion-datetime_3.entry.js": [
		68918,
		8592,
		8918
	],
	"./ion-fab_3.entry.js": [
		94028,
		8592,
		4028
	],
	"./ion-img.entry.js": [
		98107,
		8107
	],
	"./ion-infinite-scroll_2.entry.js": [
		72178,
		8592,
		2178
	],
	"./ion-input.entry.js": [
		42868,
		8592,
		123
	],
	"./ion-item-option_3.entry.js": [
		18706,
		8592,
		8706
	],
	"./ion-item_8.entry.js": [
		12099,
		8592,
		2099
	],
	"./ion-loading.entry.js": [
		84868,
		8592,
		4868
	],
	"./ion-menu_3.entry.js": [
		54377,
		8592,
		4377
	],
	"./ion-modal.entry.js": [
		15678,
		8592,
		5678
	],
	"./ion-nav_2.entry.js": [
		16735,
		8592,
		6735
	],
	"./ion-picker-column-internal.entry.js": [
		42322,
		8592,
		2322
	],
	"./ion-picker-internal.entry.js": [
		57754,
		7754
	],
	"./ion-popover.entry.js": [
		87686,
		8592,
		7686
	],
	"./ion-progress-bar.entry.js": [
		48555,
		8592,
		8555
	],
	"./ion-radio_2.entry.js": [
		30568,
		8592,
		568
	],
	"./ion-range.entry.js": [
		6231,
		8592,
		6231
	],
	"./ion-refresher_2.entry.js": [
		45772,
		8592,
		5772
	],
	"./ion-reorder_2.entry.js": [
		14977,
		8592,
		4977
	],
	"./ion-ripple-effect.entry.js": [
		42886,
		2886
	],
	"./ion-route_4.entry.js": [
		54990,
		8592,
		4990
	],
	"./ion-searchbar.entry.js": [
		13810,
		8592,
		3810
	],
	"./ion-segment_2.entry.js": [
		2446,
		8592,
		2446
	],
	"./ion-select_3.entry.js": [
		47619,
		8592,
		7619
	],
	"./ion-slide_2.entry.js": [
		28393,
		8393
	],
	"./ion-spinner.entry.js": [
		56281,
		8592,
		6281
	],
	"./ion-split-pane.entry.js": [
		35932,
		5932
	],
	"./ion-tab-bar_2.entry.js": [
		57970,
		8592,
		7970
	],
	"./ion-tab_2.entry.js": [
		80298,
		8592,
		298
	],
	"./ion-text.entry.js": [
		71006,
		8592,
		1006
	],
	"./ion-textarea.entry.js": [
		74783,
		8592,
		4783
	],
	"./ion-toast.entry.js": [
		62749,
		8592,
		2749
	],
	"./ion-toggle.entry.js": [
		55404,
		8592,
		5404
	],
	"./ion-virtual-scroll.entry.js": [
		39043,
		9043
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 50863;
module.exports = webpackAsyncContext;